<template>
    <div class="container">
        <div class="d-flex justify-content-center align-items-center vh-100">
            <div class="col-md-4">
                <div class="card">
                    <div class="card-body">
                        <div class="text-center mb-3">
                            <div class="d-flex justify-content-center mb-3">
                                <img src="/images/pentaqube.png" class="img-fluid" style="width: 275px; height: auto;" alt="Logo">
                            </div>

                            <h3 class="fw-bold">Welcome back!</h3>

                            <div class="form-text">
                                Login to continue to EASY.
                            </div>
                        </div>

                        <div v-if="error" class="alert alert-danger" role="alert">
                            {{ error }}
                        </div>

                        <form @submit.prevent="login">
                            <div class="form-floating mb-3">
                                <input v-model="username" type="text" class="form-control" id="username"
                                    placeholder="Username" required>
                                <label for="username">Username</label>
                            </div>
                            <div class="form-floating mb-3">
                                <input v-model="password" type="password" class="form-control" id="password"
                                    placeholder="Password" required>
                                <label for="password">Password</label>
                            </div>

                            <button type="submit" class="btn btn-primary rounded-pill mb-3" style="width:100%;">Login</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
import { useStore } from 'vuex';

export default {
    name: 'LoginView',
    setup() {
        const VUE_APP_EASY_API_BASE_URL = process.env.VUE_APP_EASY_API_BASE_URL
        const username = ref('');
        const password = ref('');
        const error = ref('');
        const store = useStore();

        const login = async () => {
            try {
                const response = await axios.post(VUE_APP_EASY_API_BASE_URL+'/token/', {
                    username: username.value,
                    password: password.value,
                });

                const { access, refresh } = response.data;
                store.dispatch('login', { access, refresh });
                window.location.href = '/scans/'
            } catch (err) {
                // Extract error message from the error object
                console.log(err.response)
                if (err.response && err.response.data) {
                    error.value = err.response.data.detail || "An error occurred during login.";
                } else {
                    error.value = "An unexpected error occurred.";
                }
            }
        }

        return { username, password, error, login };
    }
};
</script>
